import { createAction, props } from '@ngrx/store';
import { Invitations } from 'src/app/model/invitations';


export const getInvitationsList = createAction('GET_INVITATIONS_LIST', props<{ pending?: boolean, typeInvitations?: number }>());
export const getInvitationsListSuccess = createAction('GET_INVITATIONS_LIST_SUCCESS',
    props<{ invitationsList: Invitations[] }>());
export const getInvitationsListFailed = createAction('GET_INVITATIONS_LIST_FAILED', props<{ errorMessage: string }>());

export const resetInvitationsShareDialog = createAction('RESET_INVITATIONS_SHARE_DIALOG');
// DEVICE
export const invitationsShareDevice = createAction('INVITATIONS_SHARE_DEVICE', props<{
    email: string; firstName: string; lastName: string; remotesMax: number;
}>());
export const invitationsShareDeviceSuccess = createAction('INVITATIONS_SHARE_DEVICE_SUCCESS', props<{ message: string }>());
export const invitationsShareDeviceFailed = createAction('INVITATIONS_SHARE_DEVICE_FAILED', props<{ errorMessage: string }>());

// TH GROUP
export const invitationsThGroupShare = createAction('INVITATIONS_SHARE_THGROUP', props<{
    email: string; firstName: string; lastName: string; groupId: number;
}>());
export const invitationsThGroupShareSuccess = createAction('INVITATIONS_SHARE_THGROUP_SUCCESS', props<{ message: string }>());
export const invitationsThGroupShareFailed = createAction('INVITATIONS_SHARE_THGROUP_FAILED', props<{ errorMessage: string }>());


export const invitationsAccept = createAction('INVITATIONS_ACCEPT', props<{ token: string; }>());
export const invitationsAcceptSuccess = createAction('INVITATIONS_ACCEPT_SUCCESS', props<{ message: string }>());
export const invitationsAcceptFailed = createAction('INVITATIONS_ACCEPT_FAILED', props<{ errorMessage: string }>());

export const invitationsReject = createAction('INVITATIONS_REJECT', props<{ token: string; }>());
export const invitationsRejectSuccess = createAction('INVITATIONS_REJECT_SUCCESS', props<{ message: string }>());
export const invitationsRejectFailed = createAction('INVITATIONS_REJECT_FAILED', props<{ errorMessage: string }>());